import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, CreditCardIcon, CpuIcon, LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productImage } from '../data/offer';
const chips = ['Acceso inmediato', 'Hecho para Argentina', 'Pago seguro'];
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="bg-stage bg-grid relative isolate overflow-hidden pb-16 pt-10 sm:pb-20 sm:pt-14" data-id="element-128" data-mp="xae9351taqne">
      <div className="absolute inset-x-0 top-0 h-1.5 hazard-stripe" aria-hidden="true" data-id="element-129" data-mp="sbb5lp1hcshj" />
      <div className="absolute right-0 top-0 -z-10 h-80 w-80 border-b border-l border-gold/25" aria-hidden="true" data-id="element-130" data-mp="sd47ys528qjq" />

      <div className="mx-auto max-w-6xl px-4 text-center" data-id="element-131" data-mp="3d1aa1ojbgjfe">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-sm border border-gold/45 bg-petrolDark px-4 py-2 font-mono text-[11px] font-bold uppercase tracking-[.16em] text-gold sm:text-xs" data-id="element-132" data-mp="3d2tpxe128sgn">
          <CpuIcon className="h-4 w-4" data-id="element-133" data-mp="399bc1q3avhx1" /> Megapack Automatización Industrial Listo™
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-4xl text-balance text-4xl font-extrabold uppercase leading-[1.02] text-white sm:text-6xl md:text-7xl" data-id="element-134" data-mp="3e84odf6up2vm">
          Del diagnóstico a la acción.<br data-id="element-135" data-mp="2viol4k3s6wbi" />
          <span className="text-gold" data-id="element-136" data-mp="2vi53z5lygbyj">Todo resuelto.</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto my-5 max-w-2xl sm:my-7" data-id="element-137" data-mp="2hjf63nrba894">
          <img src={productImage} alt="Megapack Automatización Industrial Listo: nueve tomos y cinco bonos sobre PLC, sensores, motores, redes industriales y HMI" className="mx-auto w-full drop-shadow-[0_24px_44px_rgba(2,10,18,.6)]" data-id="element-138" data-mp="s3mf683jc910" />
        </motion.div>

        <div className="flex flex-wrap justify-center gap-2 text-xs font-bold text-onDark" data-id="element-139" data-mp="deylk7d929dp">
          {chips.map(item => <span key={item} className="inline-flex items-center gap-1.5 rounded-sm border border-lineDark bg-petrolDark px-3 py-2" data-id="element-140" data-mp="1ayjf37ngf433">
              <CheckIcon className="h-3.5 w-3.5 text-gold" aria-hidden="true" data-id="element-141" data-mp="111yagnfcjuzs" /> {item}
            </span>)}
        </div>

        <div className="mt-7" data-id="element-142" data-mp="x0l2o7sp1hq8">
          <Button onClick={scrollToPricing} arrow data-id="element-143" data-mp="x3h62bnb8ym2">QUIERO MI MEGAPACK AHORA</Button>
        </div>

        <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-mutedDark" data-id="element-144" data-mp="3lqm4435bldx1">
          <span className="inline-flex items-center gap-1.5" data-id="element-145" data-mp="1x9ku2l5yd2go"><ShieldCheckIcon className="h-4 w-4 text-gold" data-id="element-146" data-mp="1xaw06rmvemay" /> Garantía 7 días</span>
          <span className="inline-flex items-center gap-1.5" data-id="element-147" data-mp="21bxz17cvkwce"><LockIcon className="h-4 w-4 text-gold" data-id="element-148" data-mp="218jzs7zid396" /> Pago seguro</span>
          <span className="inline-flex items-center gap-1.5" data-id="element-149" data-mp="268of3uoojrxt"><CreditCardIcon className="h-4 w-4 text-gold" data-id="element-150" data-mp="2b195sncahox4" /> Mercado Pago</span>
        </div>

        <p className="mx-auto mt-5 flex max-w-3xl items-start justify-center gap-2 text-balance text-xs font-semibold text-mutedDark" data-id="element-151" data-mp="2g02jogvhnhxt">
          <ZapIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" data-id="element-152" data-mp="2kxkktl39ksv9" /> Para docentes, profesores e instructores de escuelas técnicas, formación
          profesional y espacios de Automatización Industrial de toda Argentina
        </p>
      </div>
    </section>;
}